<script lang="ts">
    import tngLogo from '../assets/tng.svg';
    import { Link } from 'svelte-navigator';
</script>

<footer>
    <a class="link" href="https://tngtech.com">
        <img class="logo" src={tngLogo} alt="TNG Technology Consulting GmbH" />
    </a>
    <nav
        aria-label="Secondary menu"
        class="secondary-links navbar navbar-expand-sm navbar-dark"
    >
        <ul class="navbar-nav">
            <li class="nav-item">
                <Link class="nav-link" to="imprint">Imprint</Link>
            </li>
            <li class="nav-item">
                <Link class="nav-link" to="privacy">Privacy Statement</Link>
            </li>
        </ul>
    </nav>
</footer>

<style>
    footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 3rem;
        box-sizing: border-box;
        font-size: 1.8rem;
        text-align: center;
        background-color: var(--bs-dark) !important;
    }

    .logo {
        height: 1.5rem;
    }

    .link:link,
    .link:visited {
        color: var(--primary-foreground);
    }

    .secondary-links {
        position: absolute;
        right: 1rem;
        bottom: 0;
        --bs-nav-link-font-size: 16px;
    }
</style>
